import { render, staticRenderFns } from "./PurchaseReturnDetail.vue?vue&type=template&id=b8de1ca6&"
import script from "./PurchaseReturnDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8de1ca6')) {
      api.createRecord('b8de1ca6', component.options)
    } else {
      api.reload('b8de1ca6', component.options)
    }
    module.hot.accept("./PurchaseReturnDetail.vue?vue&type=template&id=b8de1ca6&", function () {
      api.rerender('b8de1ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/PurchaseReturnDetail.vue"
export default component.exports